import Head from "next/head";
import { ReactNode } from "react";

const SubPageLayout = ({
  title,
  titleImgSrc,
  bgImgUrl,
  spBgImgUrl,
  isMobile,
  extraContainerClass,
  children,
  isForGallery,
}: {
  title: string;
  titleImgSrc: string;
  bgImgUrl: string;
  spBgImgUrl?: string;
  isMobile: boolean;
  extraContainerClass?: string;
  children: ReactNode;
  isForGallery?: boolean;
}) => (
  <>
    <Head>
      <title>{title}</title>
    </Head>

    <Background
      title={title}
      titleImgSrc={titleImgSrc}
      bgImgUrl={bgImgUrl}
      spBgImgUrl={spBgImgUrl}
      isMobile={isMobile}
      isForGallery={isForGallery}
    />

    <div
      className={`my-0 mx-auto relative ${
        isMobile ? "px-[16px]" : "max-w-[1300px]"
      } ${extraContainerClass} ? ${extraContainerClass} : ""}`}
    >
      {children}
    </div>
  </>
);

const Background = ({
  title,
  titleImgSrc,
  bgImgUrl,
  spBgImgUrl,
  isMobile,
  isForGallery = false,
}: {
  title: string;
  titleImgSrc: string;
  bgImgUrl: string;
  spBgImgUrl?: string;
  isMobile: boolean;
  isForGallery?: boolean;
}) => (
  <div>
    <div
      className={`fixed  h-screen -z-10 opacity-80 left-[-4px] ${
        isMobile
          ? isForGallery
            ? "top-[134px]"
            : "top-[48px]"
          : "top-[100px] bg-black"
      }`}
    >
      {/*eslint-disable-next-line @next/next/no-img-element*/}
      <img src={titleImgSrc} alt={title} width={isMobile ? 92 : 200} />
    </div>
    {isMobile && spBgImgUrl && <BackgroundImage bgImgUrl={spBgImgUrl} />}
    {!isMobile && <BackgroundImage bgImgUrl={bgImgUrl} />}
  </div>
);

const BackgroundImage = ({ bgImgUrl }: { bgImgUrl: string }) => {
  return (
    <div
      style={{ backgroundImage: `url('${bgImgUrl}')` }}
      className="bg-no-repeat bg-cover fixed top-0 left-0 w-full h-screen -z-20"
    />
  );
};

export default SubPageLayout;
